module.exports = __webpack_public_path__ + "static/media/get-recommendations-tabletPro-en.3b2174e1.webp";